import React, {Component, type ReactNode} from "react";
import type {Organization} from "@App/types";
import {Trans} from "react-i18next";
import type {FontSize} from "@App/utils/tailwind/fontsize";

type HeroProps = {
    title: string,
    subtitle?: string
    backgroundImage: string
    backgroundPosition?: string
    height?: number
    organization?: Organization
    titleFontSize?: FontSize
    subTitleFontSize?: FontSize
}

export class Hero extends Component<HeroProps> {

    render(): ReactNode {
        return (
            <div className={"h-64 relative"}>
                <div className="w-full h-full">
                    <div
                        className={`bg-${this.props.backgroundImage} bg-cover ${this.props.backgroundPosition ? this.props.backgroundPosition : 'bg-center md:bg-top'} min-h-[217px] h-full`}/>
                </div>
                <div
                    className="absolute top-0 left-0 flex justify-center items-center w-full h-full">
                    <div className="container text-white">
                        <div className={`font-serif ${this.props.titleFontSize || "text-3xl"} text-left w-full drop-shadow-md`}>
                            <Trans i18nKey="hero.title" values={{organization: this.props.organization.name}}>{this.props.title}</Trans>
                        </div>
                        {this.props.subtitle && (
                            <div className={`font-serif ${this.props.titleFontSize || "text-xl"} text-left w-full drop-shadow-md`}>
                                {this.props.subtitle}
                            </div>
                        )}
                        <div className="text-left w-full text-lg font-bold flex pt-3 drop-shadow-md">
                            <div className="mr-1">
                                powered by
                            </div>
                            <div>
                                <img src="/images/brand/logo-extra-light-blue.svg" className="w-24" alt=""/>
                            </div>
                        </div>
                        </div>
                    </div>
            </div>
        );
    }
}
